/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { logger as log } from '@common/logger';
import { injectable } from 'inversify';
import { TAgent, getAgent } from './agent';
import { RegisterUserProps } from './plugins';
import { useRegisterToken } from '../provider';

const is = require('is_js');

const SERVICE_NAME = 'RegisterPageService';

@injectable()
export class RegisterPageService {
  public agent: TAgent;
  private readonly loginRestAPI: string;
  private readonly headers: any;
  private readonly signerPK: string;
  static displayName = 'RegisterPageService';
  constructor(props: any = {}) {
    this.agent = getAgent();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.signerPK = props.signerPK;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async registerUser(args: RegisterUserProps) {
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return await agent.registerUser(_args);
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const { token, decodedToken } = useRegisterToken();
    // const agent = getAgent();
    // const { token, decoded } = await agent?.parseAndDecodeToken({
    //   signerPK: this.signerPK,
    // });
    content = {
      ...content,
      initialData: {
        email: decodedToken?.email,
        firstName: decodedToken?.firstName,
        lastName: decodedToken?.lastName,
      },
      token: token,
      isPassword: decodedToken?.authType === 'PASSWORD',
    };
    console.log(`content getPageContent:`, decodedToken, content);
    return content;
  }
}
